export enum ActualTripSelectorMode {
  summary,
  edit,
}
